module.exports = __webpack_public_path__ + "img/prodotto.fffa75c5.png";